import { useInvoiceInfo } from '../InvoiceInfoProvider';
import BillingRow from './BillingRow';
import InvoiceActionsRow from './InvoiceActionsRow';
import InvoiceInfoRow from './InvoiceInfoRow';
import SubscriptionInfoRow, { ServiceInfoRow } from './SubscriptionInfoRow';

function InfoContainer({ children, className }) {
    return (
        <div
            className={`rounded-[20px] shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] p-5 mb-4 ${className}`}
        >
            {children}
        </div>
    );
}

function InvoiceInfoRightCol({ invoiceData, billingAddress, invoiceItems }) {
    const { openModal } = useInvoiceInfo();

    return (
        <div>
            <InfoContainer>
                <InvoiceActionsRow openModal={openModal} invoiceData={invoiceData} />
            </InfoContainer>
            <InfoContainer>
                <InvoiceInfoRow invoiceData={invoiceData} billingAddress={billingAddress} />
            </InfoContainer>

            <InfoContainer>
                <BillingRow openModal={openModal} invoiceData={invoiceData} />
            </InfoContainer>
            {invoiceItems?.filter((item) => item?.productType === 'subscription').length ? (
                <InfoContainer className="min-h-52">
                    <SubscriptionInfoRow
                        openModal={openModal}
                        invoiceItems={invoiceItems}
                        invoiceData={invoiceData}
                    />
                </InfoContainer>
            ) : (
                <InfoContainer className="min-h-52">
                    <ServiceInfoRow
                        openModal={openModal}
                        invoiceItems={invoiceItems}
                        invoiceData={invoiceData}
                    />
                </InfoContainer>
            )}

            {}
        </div>
    );
}

export default InvoiceInfoRightCol;
